import { useEffect, useMemo, useState } from "react"
import _ from "underscore";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { useFilter } from "../../../context/FIlterContext";
import { callautopopulate } from "../../../services/callautopop";

export const useCategoryInfo = () => {
    const { projectFilter, setProjectFilter } = useFilter();
    const [loader, setLoader] = useState(false);
    const [chartData, setChartData] = useState();
    const [filterData, setFilterData] = useState({
        hoveredRange: [],
        is_with_done: false,
        hierarchy: 1,
        apiCall: false,
        isChange:false
    });
    const [issueTypeGroupOption, setIssueTypeGroupOption] = useState([])

    const options = {
        credits: { enabled: false },
        chart: {
            type: "pie",
        },
        title: {
            text: "",
        },
        plotOptions: {
            pie: {
                innerSize: "60%",
                dataLabels: {
                    enabled: false
                },
                showInLegend: true,
            },
        },
        legend: {
            layout: "vertical",
            useHTML: true,
            align: "left",
            verticalAlign: "middle",
            labelFormatter: function () {
                return `<div class="d-flex gap-2"><span>${this.name}</span> <b>${this.percentage.toFixed(2)}%</b></div>`
            }
        },
        series: [
            {
                name: "issue Type",
                colorByPoint: true,
                data: chartData,
            },
        ],
    };

    useEffect(() => {
        callautopopulate("issue_type_groups").then((res) => {
            setIssueTypeGroupOption(res?.issue_type_groups)
        }).catch((err) => {
            console.error(err)
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        projectFilter?.apiCall && GetProjectIssueTypeSummarData();
    }, [projectFilter?.apiCall])

    useEffect(() => {
        filterData?.apiCall && GetProjectIssueTypeSummarData();
    }, [filterData?.apiCall])

    const GetProjectIssueTypeSummarData = async () => {
        try {
            setLoader(true)
            const payload = {
                client_id: projectFilter?.client_id?.client_id || 0,
                project_ids: _.pluck(projectFilter?.project_ids, 'project_id')?.toString(),
                lead_user_code: projectFilter?.lead_user_code?.user_code || 0,
                request_user_code: projectFilter?.request_user_code || 0,
                project_module_ids: _.pluck(projectFilter?.project_module_ids, 'option_id')?.toString(),
                feature_ids: _.pluck(projectFilter.feature_ids, 'issue_id')?.toString(),
                issue_key: projectFilter?.issue_id,
                hiearchy_level: filterData?.hierarchy,
                is_with_done: filterData?.is_with_done,
                from_date: filterData?.hoveredRange?.[0]?.toDate()?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") || "",
                to_date: filterData?.hoveredRange?.[1]?.toDate()?.toLocaleDateString("en-GB")?.split("/")?.reverse()?.join("-") || ""
            };
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTISSUETYPESUMMARY'), payload);
            const projectIssue = res?.body?.data?.project_issue_type_summary || [];
            const pieChartData = projectIssue.map(item => ({
                name: item.issue_type_name,
                y: item.total_issues,
            }));
            setChartData(pieChartData);
            setLoader(false);
            setProjectFilter(prev => ({ ...prev, apiCall: false }));
            setFilterData(prev => ({ ...prev, apiCall: false,isChange:false }))
        } catch (error) {
            setLoader(false);
            console.error('Error:', error);
            setFilterData(prev => ({ ...prev, apiCall: false }))
            setProjectFilter(prev => ({ ...prev, apiCall: false }));
        }
    };

    return useMemo(() => ({
        filterData, setFilterData, options, loader, chartData, issueTypeGroupOption, GetProjectIssueTypeSummarData
    }), [filterData, setFilterData, options, loader, chartData, issueTypeGroupOption, GetProjectIssueTypeSummarData])

}